import { Avatar, Button, Dropdown, Image } from "antd";
import { useNavigate } from "react-router-dom";
import { CrossIcon, TickIcon } from "../../../../../atoms/CustomIcons";
import { CaretDownOutlined } from "@ant-design/icons";
import { useRef } from "react";
import { GetDealType, ProposalDetailType } from "../../../ducks/types";

interface HeaderProps {
  companyId: string;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  btnText2?: string;
  estimateId: string;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  dealsDetailData: GetDealType | null;
  addProposal?: boolean;
  proposalDetailData: ProposalDetailType | null;
  handleSubmitEstimate: () => void;
  handleSubmitProposalDoc: () => void;
  proposalId?: string;
  dealId?: string;
}

export default function Header({
  companyId,
  btnText1,
  btnIcon1,
  btnText2,
  setLoading,
  dealsDetailData,
  addProposal,
  proposalDetailData,
  estimateId,
  handleSubmitEstimate,
  handleSubmitProposalDoc,
}: HeaderProps) {
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const changeStatus = (val: string) => {
    setLoading(true);
    functionChangeStatus(val);
  };

  const functionChangeStatus = (val: string) => {
    const payload = {
      status: val,
    };
    console.log("payload", payload);
  };

  const statusItems = [
    {
      key: "inactive",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("inactive");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />{" "}
          Inactive{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "onboarding",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("onboarding");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#2098EE", borderRadius: "2px" }}
          />{" "}
          Onboarding{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "active",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("active");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />{" "}
          Active{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "suspended",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("suspended");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#F06400", borderRadius: "2px" }}
          />{" "}
          Suspended{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "archived",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            changeStatus("archived");
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <Avatar
            shape="square"
            size={16}
            style={{ backgroundColor: "#98A3A9", borderRadius: "2px" }}
          />{" "}
          Archived{" "}
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  return (
    <div className="estimateHeader">
      <div className="headerLeft">
        <Button
          size="large"
          type="link"
          className="p-0 m-20 close_popup"
          onClick={() => navigate(`/deals-detail/${estimateId}/${companyId}`)}
          icon={<CrossIcon style={{ color: "#151718" }} />}
        />
        <div className="estimateHeaderText">
          <div className="estimateTitle">
            <div className="estimateTitleText">
              {dealsDetailData?.name ?? ""} : <b>Estimate</b>
            </div>
            {!addProposal && (
              <Dropdown
                menu={{
                  items: statusItems,
                  selectable: true,
                }}
                trigger={["click"]}
                overlayClassName="status_dropdown_overlay"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  className={`status_dropdown in_progress_status`}
                  ref={dropdownRef}
                >
                  {proposalDetailData?.status === "in_progress"
                    ? "In progress"
                    : proposalDetailData?.status === "approval_pending"
                    ? "Approval pending"
                    : proposalDetailData?.status}
                  <div className="icon_arrow">
                    <CaretDownOutlined />
                  </div>
                </Button>
              </Dropdown>
            )}
          </div>
          <div className="description">
            <Image src="/images/estimate/home-icon.svg" preview={false} />
            {dealsDetailData?.property?.name ?? ""}
          </div>
        </div>
      </div>
      {(btnText1 || btnText2) && (
        <div className="two_btns">
          {btnText1 && (
            <Button htmlType="submit" size="large" className="btn-sm">
              {btnIcon1 && btnIcon1} {btnText1}
            </Button>
          )}
          <Button onClick={handleSubmitEstimate} className="white-btn">
            Save
          </Button>
          {btnText2 && (
            <Button
              htmlType="submit"
              size="large"
              className="mint-btn"
              onClick={handleSubmitProposalDoc}
            >
              {btnText2}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
